import { CALL_API } from 'middlewares/api';
import { url } from 'configs/';
const {
  NEWTUBE_API_SERVER,
  API_SERVER,
} = url;

const FETCH_USERAUTHORITY_REQUEST = 'fouindation/userReducer/FETCH_USERAUTHORITY_REQUEST';
const FETCH_USERAUTHORITY_SUCCESS = 'fouindation/userReducer/FETCH_USERAUTHORITY_SUCCESS';
const FETCH_USERAUTHORITY_ERROR = 'fouindation/userReducer/FETCH_USERAUTHORITY_ERROR';

const FETCH_SPECIAL_ROLE_REQUEST = 'tube/app/user/FETCH_SPECIAL_ROLE_REQUEST';
const FETCH_SPECIAL_ROLE_SUCCESS = 'tube/app/user/FETCH_SPECIAL_ROLE_SUCCESS';
const FETCH_SPECIAL_ROLE_ERROR = 'tube/app/user/FETCH_SPECIAL_ROLE_ERROR';

export default function reducer(state = {
  isLoading: false,
  isLoaded: false,
  datas: [],
  isRoleLoading: false,
  specialRole: {
    isSupervisor: false,
  },
}, action) {
  switch (action.type) {
    case FETCH_USERAUTHORITY_REQUEST:
      return Object.assign({}, state, {
        isLoading: true,
        isLoaded: false,
      });
    case FETCH_USERAUTHORITY_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        isLoaded: true,
        datas: action.response.data,
      });
    case FETCH_SPECIAL_ROLE_REQUEST:
      return Object.assign({}, state, {
        isRoleLoading: true,
      });
    case FETCH_SPECIAL_ROLE_SUCCESS:
      const specialRole = Object.assign({}, state.specialRole);
      const response = action.response;
      specialRole.isSupervisor = response.isSupervisor;
      return Object.assign({}, state, { specialRole, isRoleLoading: false });
    default:
      return state;
  }
}

export function fetchUserAuthority() {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'userInfo',
      method: 'GET',
      types: [
        FETCH_USERAUTHORITY_REQUEST,
        FETCH_USERAUTHORITY_SUCCESS,
        FETCH_USERAUTHORITY_ERROR,
      ],
    },
  };
}

export function fetchSpecialRole() {
  return {
    [CALL_API]: {
      url: API_SERVER + 'company/I_PA_Employee/GetSpecialRole',
      method: 'GET',
      types: [FETCH_SPECIAL_ROLE_REQUEST, FETCH_SPECIAL_ROLE_SUCCESS, FETCH_SPECIAL_ROLE_ERROR],
    },
  };
}



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/containers/App/screens/Foundation/reducers/userReducer.js
 **/